export default class TextareaCounter {
	constructor({ elements }) {
		elements.forEach((el) => {
			// append counter html to textbox
			if (el.dataset.textareaCounter > 0) {
				const { textareaCounter, counterWithoutError } = el.dataset;
				if (!counterWithoutError && el.dataset.errorMessage) {
					this.errorMessage = el.dataset.errorMessage;
					el.insertAdjacentHTML(
						'afterend',
						`<div class="counter-container"><div class="textarea-counter">${textareaCounter}</div>
						<div class="counter__error-message hide">${this.errorMessage}</div></div>`
					);
				} else {
					el.insertAdjacentHTML(
						'afterend',
						`<div class="counter-container flex flex--self-end"><div class="textarea-counter textarea-counter--alt">${textareaCounter}</div>`
					);
				}
				// wire up listener
				el.addEventListener('keyup', (e) => {
					const maxCharacters = e.target?.dataset.textareaCounter;
					const characters = e.target?.value?.length;
					// update char count
					TextareaCounter.updateCharCount({
						el,
						target: e.target,
						maxCharacters,
						characters,
						textareaCounter,
						counterWithoutError,
					});
				});
				el.addEventListener('focus', (e) => {
					const maxCharacters = e.target?.dataset.textareaCounter;
					const characters = e.target?.value?.length;
					// update char count
					TextareaCounter.updateCharCount({
						el,
						target: e.target,
						maxCharacters,
						characters,
						textareaCounter,
						counterWithoutError,
					});
				});
			}
		});
	}

	static updateCharCount({
		target,
		maxCharacters,
		characters,
		textareaCounter,
		counterWithoutError,
	}) {
		const counter = target.nextSibling.childNodes[0];
		counter.innerHTML = textareaCounter - characters;
		if (!counterWithoutError) {
			const errorMessageBox = target.nextSibling.childNodes[2];
			if (characters > maxCharacters) {
				counter.classList.add('textarea-counter__error');
				errorMessageBox.classList.remove('hide');
			}
			if (characters <= maxCharacters) {
				counter.classList.remove('textarea-counter__error');
				errorMessageBox.classList.add('hide');
			}
		}
	}
}
